import React, { useState } from "react";
import "./AddingConcert.css";
import { addConcert } from "./ConcertApi"; // Dodanie odpowiedniego importu z pliku ConcertApi
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate"; // Dodajemy hooka useAxiosPrivate

const AddConcertModal = () => {
  const [concertName, setConcertName] = useState("");
  const [concertTime, setConcertTime] = useState("");
  const [concertDate, setConcertDate] = useState("");
  const [hostName, setHostName] = useState("");

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  
  const handleCloseModal = () => {
    clearForm();
    navigate(-1);
  };

  const isValidDateTime = (date: string, time: string) => {

    const datePattern = /^\d{4}-\d{2}-\d{2}$/; 
    const timePattern = /^\d{2}:\d{2}$/; 
    return datePattern.test(date) && timePattern.test(time);
  };

  const handleAddConcert = () => {
    if (!concertName || !concertTime || !concertDate || !hostName) {
      alert("Wszystkie pola są wymagane!");
      return;
    }

    // Walidacja daty i godziny
    if (!isValidDateTime(concertDate, concertTime)) {
      alert("Podaj poprawny format daty (YYYY-MM-DD) i godziny (HH:mm)!");
      return;
    }

    // Połączenie daty i godziny w jeden datetime
    const dateTime = `${concertDate} ${concertTime}`;

    const concertData = {
      place: concertName,
      date: dateTime,  // Połączony datetime
      host: hostName,
    };

    addConcert(
      axiosPrivate,
      concertData,
      (response) => {
        console.log("Dodano koncert:", response);
        alert("Koncert został dodany!");
        clearForm();
      },
      (error) => {
        console.error("Błąd podczas dodawania koncertu:", error);
        alert("Wystąpił błąd podczas dodawania koncertu.");
      }
    );
  };

  const clearForm = () => {
    setConcertName("");
    setConcertTime("");
    setConcertDate("");
    setHostName("");
  };

  return (
    <div className="custom-modal-addconcert">
      <div className="custom-modal-content-addconcert">
        <button onClick={handleCloseModal} className="close-button">
          ✖
        </button>
        <h3 className="modal-title">Dodaj koncert</h3>
        <div className="form-container-addconcert">
          <div className="row-addconcert">
            <div className="form-group-addconcert">
              <label>Nazwa koncertu</label>
              <input
                type="text"
                placeholder="Wpisz tutaj"
                value={concertName}
                onChange={(e) => setConcertName(e.target.value)}
                className="modal-input-addconcert"
              />
            </div>
            <div className="form-group-addconcert">
              <label>Godzina rozpoczęcia</label>
              <input
                type="time" // Zmieniliśmy typ na 'time'
                value={concertTime}
                onChange={(e) => setConcertTime(e.target.value)}
                className="modal-input-addconcert"
              />
            </div>
            <div className="form-group-addconcert">
              <label>Data</label>
              <input
                type="date" // Zmieniliśmy typ na 'date'
                value={concertDate}
                onChange={(e) => setConcertDate(e.target.value)}
                className="modal-input-addconcert"
              />
            </div>
          </div>
          <div className="row-addconcert">
            <div className="form-group-addconcert">
              <label>Prowadzący</label>
              <input
                type="text"
                placeholder="Wpisz tutaj"
                value={hostName}
                onChange={(e) => setHostName(e.target.value)}
                className="modal-input-addconcert modal-input-hostname"
              />
            </div>
          </div>
        </div>
        <div className="modal-event-buttons-addconcert">
          <button onClick={handleAddConcert} className="custom-modal-button-addconcert">
            Dodaj
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddConcertModal;
